module.exports = __webpack_public_path__ + "img/dumbbell-light-green.e9869f64.png";